import { getStoreActions } from "../../../utils/session/storeStateUtils";
import { getTranslationFunction } from "../../../utils/core/translationUtils";
import { logRedirectDisplayOutput } from "../../../utils/core/debugUtils";
import { parseMarkedText } from "../../../utils/ui/outputProcessingUtils";

/**
 * Displays the stepOutro output before redirect
 * @param {string|Promise<string>} output - The output to display
 */
export async function displayRedirectStepOutro(output) {
  const { addOutputWithTypingEffect } = getStoreActions();
  const t = getTranslationFunction();

  const resolvedOutput = await Promise.resolve(output).catch(() =>
    t("errorOccurred")
  );

  // Push the whole resolved output as a SINGLE entry — see notes in
  // promptHandlers.handleStepComplete for the rationale.
  let outputText = resolvedOutput;
  if (typeof outputText === "string") {
    outputText = outputText.replace(/(?:\n\s*)+$/, "");
  }
  if (typeof outputText !== "string" || outputText.length > 0) {
    await addOutputWithTypingEffect([
      { type: "output", text: parseMarkedText(outputText) },
    ]);
  }
}

/**
 * Displays output when redirect command completes
 * @param {string|Promise<string>} output - The output to display
 */
export async function displayRedirectCompletionOutput(output) {
  logRedirectDisplayOutput();
  const { addOutputWithTypingEffect } = getStoreActions();
  const t = getTranslationFunction();

  const resolvedOutput = await Promise.resolve(output).catch(() =>
    t("errorOccurred")
  );

  // Push the whole resolved output as a SINGLE entry — see notes in
  // promptHandlers.handleStepComplete for the rationale.
  let outputText = resolvedOutput;
  if (typeof outputText === "string") {
    outputText = outputText.replace(/(?:\n\s*)+$/, "");
  }
  if (typeof outputText !== "string" || outputText.length > 0) {
    await addOutputWithTypingEffect([
      { type: "output", text: parseMarkedText(outputText) },
    ]);
  }
}
